import script from "./forgetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./forgetPassword.vue?vue&type=script&setup=true&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=a3ca8652&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\chatgpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3ca8652"]])

export default __exports__